export const getLoginSource = (
  international?: boolean,
): 'InternationalLoginForm' | 'LoginForm' => {
  return international ? 'InternationalLoginForm' : 'LoginForm';
};
